export default [
  {
    path: '/setor',
    name: 'setor',
    component: () => import(/* webpackChunkName: "setor" */ './Setor.vue')
  }
]
